<template>
  <div class="Company">
    <div class="cont">
      <div class="c_left wow slideInLeft">
        <ComTitlte
          titleEn="ABOUT US "
          titleZh="关于我们"
          zhColor="#333333"
        ></ComTitlte>
        <div class="c_info">
          <p>
            广州统计师事务所于1998年8月成立，与原广州市统计咨询中心（广州市统计局下属公益三类事业单位）是“一套人马两块牌子”合署办公，原属广州市统计局监管，现属广州工业投资控股集团有限公司，受广州市人民政府国有资产监督管理委员会监管。
          </p>
          <p>
            广州统计师事务所是一家对外开展统计调查和提供信息咨询服务的国有企业，作为具备本地化服务能力和拥有良好商业信誉及丰富业务经验的专业机构，始终坚持利用统计数据和网络资源，为社会各界提供精准统计调查服务，其中部分调研成果受到市委市政府及相关职能部门的肯定。
          </p>
        </div>
        <router-link class="buttonSeeDetails" to="/company">
          查看详情>>
        </router-link>
      </div>
      <div class="c_right wow slideInRight">
        <img alt="Company" src="../../assets/img/index/company_img.png" />
      </div>
    </div>
  </div>
</template>

<script>
import ComTitlte from "@/components/common/comTitle";

export default {
  name: "Company",
  mounted() {
    // 在项目加载完成之后初始化wow
    this.$nextTick(() => {
      new this.$wow({
        //默认为true
        live: false,
      }).init();
    });
  },
  components: { ComTitlte },
};
</script>

<style lang="scss" scoped>
$themeColor: #406cdd;
.Company {
  width: 100%;
  height: 437px;
  min-width: 1180px;
  background: url("../../assets/img/index/cont_Company.png") center no-repeat;
  background-size: cover;
  overflow: hidden;

  .cont {
    display: flex;
    justify-content: space-between;
    width: 1180px;
    height: 100%;
    margin: 0 auto;

    .c_left {
      flex: 1;

      .c_info {
        padding: 30px 0;
        font-size: 16px;
        line-height: 30px;
        text-indent: 32px;
        color: #666666;
      }

      .buttonSeeDetails {
        width: 130px;
        height: 34px;
        line-height: 34px;
        text-align: center;
        background-color: $themeColor;
        border-radius: 10px;
        font-size: 16px;
        color: #ffffff;
      }
    }

    .c_right {
      width: 430px;
      height: 100%;
      text-align: right;

      img {
        padding: 80px 0 0 0;
        display: inline-block;
        width: 300px;
      }
    }
  }
}
</style>
